import React from 'react';

import ROUTE_PATHS from '@/consts/route/routePaths';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import uwmService from '@/services/uwm/uwmService';
import HomePageLayout from '@/views/Home/HomePageLayout';
import UwmModule from '@/views/UwmModule/UwmModule';

const LoyaltyDetailsPage = () => {
    const isDesktopLayout = useIsDesktopLayout();

    return isDesktopLayout ? (
        <HomePageLayout activePath={ROUTE_PATHS.HOME_PAGE}>
            <UwmLoyaltyModule />
        </HomePageLayout>
    ) : (
        <UwmLoyaltyModule />
    );
};

const UwmLoyaltyModule = () => {
    const onModuleLoaded = () => {
        uwmService.postLoyaltyInitMessage();
        uwmService.postMarketLocaleInitMessage();
    };

    return <UwmModule onModuleLoaded={onModuleLoaded} src={process.env.REACT_APP_UWM_LOYALTY_SRC} />;
};

export default LoyaltyDetailsPage;
